import { LoadableAfterPaint } from '@confluence/loadable';

export const AdminNavigationLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AdminNavigation" */ '../src/AdminNavigation/index.tsx'))
			.AdminNavigation,
});
